<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Button from 'primevue/button';

interface Props {
    variant?: 'primary' | 'secondary';
    size?: 'small' | 'normal';
    disabled?: boolean;
    outlined?: boolean;
    class?: string;
}

const props = withDefaults(defineProps<Props>(), {
    variant: 'primary',
    size: 'normal',
    disabled: false,
    outlined: false,
    class: ''
});

const emit = defineEmits(['click', 'add-item']);

const { t } = useI18n();

const handleClick = () => {
    emit('click');
    emit('add-item');
};
</script>

<template>
    <Button
        :label="t('textMaintenance.addIdentifier')"
        icon="pi pi-plus"
        :severity="variant"
        :size="size"
        :disabled="disabled"
        :class="[outlined ? 'p-button-outlined' : '', props.class]"
        @click="handleClick"
        data-cy="text-maintenance_add-identifier-button"
    />
</template>